<!-- Экран записи на пробный урок -->
<template>
    <!-- <div class="white_container reserve_lesson_container">
   <h2 class="reserve_lesson_header">{{$t("lesson.LBL_TRIAL_LESSON_TITLE")}}</h2>
   <div class="reserve_lesson_body">
       <div class="calendar_wrapper">
           <span class="calendar_text">{{$t("lesson.LBL_TRIAL_LESSON_DATES_SELECT")}}</span>
           <div class="selected-date-container">
               <div class="prev-container" :class="{'active':has_prev}" @click="prev">
                   <div class="icon-wrapper">
                       <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path fill-rule="evenodd" clip-rule="evenodd" d="M2.41421 7L7.70711 12.2929C8.09763 12.6834 8.09763 13.3166 7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071L0.292893 7.70711C-0.0976305 7.31658 -0.0976305 6.68342 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893C8.09763 0.683418 8.09763 1.31658 7.70711 1.70711L2.41421 7Z" />
                       </svg>
                   </div>
               </div>
               <div class="current-date-container">
                   <div class="date-container">
                       <span class="selected-date">{{typeof view_date.day != 'undefined'?view_date.day:""}} {{$t("strings.MONTH_"+parseInt(view_date.mon))}}</span>
                       <span class="selected-day">{{$tc("strings."+selected_day,1)}}</span>
                   </div>
               </div>
               <div class="next-container" :class="{'active':has_next}" @click="next">
                   <div class="icon-wrapper">
                       <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                           <path fill-rule="evenodd" clip-rule="evenodd" d="M5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893C0.683418 -0.0976305 1.31658 -0.0976305 1.70711 0.292893L7.70711 6.29289C8.09763 6.68342 8.09763 7.31658 7.70711 7.70711L1.70711 13.7071C1.31658 14.0976 0.683418 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58579 7Z" />
                       </svg>
                   </div>
               </div>
           </div>
       </div>
       <div class="day_schedule">
           <DaySchedule :hours="list" v-on:selectedHourEvent="selectedHourEvent"/>
       </div>
   </div>
   <div class="reserve_lesson_footer">
       <div class="reserve_lesson-form">
           <div class="button-wrapper form-wrapper">
               <div class="form-field primary-button-form">
                   <button :disabled="selectedHour == null" class="button" @click="lessonBookingEvent">
                       <span>{{$t("strings.BTN_CONFIRM")}}</span>
                   </button>
               </div>
           </div>
       </div>
   </div>
   <BookingErrorPopup
   :show="booking_error"
   v-on:closeEvent="BookingErrorPopupCloseEvent"
   ></BookingErrorPopup>
   </div> -->
<div class="white_container" style="padding:5px;">
   <h2 class="choose_timetable_top_text">Alege orarul</h2>
   <p class="choose_timetable_under_top_text">Maria, ai cumpărat 4 lecții individuale cu profesorul. Înainte de
      a da start lecțiilor a rămas să alegeți orarul și intensitatea
   </p>
   <h2 class="many_times_text">De câte ore pe săptămână veți face lecții ?</h2>
   <div class="week_days_number">
      <div class="days_1">
      <div class="days" style="background: #CF0920;">
         <p style="color:white;" class="numbers">1</p>
      </div>
      <div class="days">
         <p class="numbers">2</p>
      </div>
      <div class="days">
         <p class="numbers">3</p>
      </div>
      <div class="days">
         <p class="numbers">4</p>
      </div>
      </div>
      <div class="days_2">
      <div class="days">
         <p class="numbers">5</p>
      </div>
      <div class="days">
         <p class="numbers">6</p>
      </div>
      <div class="days">
         <p class="numbers">7</p>
      </div>
      </div>
   </div>
   <div class="teacher_review_block">
      <div class="teacher_photo">
         <img src="@/assets/img/methodist.png" alt="#">
      </div>
      <div class="teacher_text">
         <h2 class="teacher_head_text">Recomandarea metodistului</h2>
         <p class="teacher_bottom_text">Este potrivit pentru repetarea și întărirea cunoștințelor, va trebui de ocupat 
            mult de sinestătător, de a efectua tema pentru acasă și testele. În total 4 lecții 
            pe lună, aceasta este de câteva ori mai puțin decât tempoul recomandat.
         </p>
      </div>
   </div>
   <h2 class="ready_text">Când sunteți gata să începeți?</h2>
   <div class="choose_blocks">
      <div class="choose_block1">
         <img src="@/assets/img/fireclock.png" alt="#" class="chosse_img">
         <h2 class="chosse_txt" style="color: #FFFFFF;">Oricând</h2>
      </div>
      <div class="choose_block2">
         <img src="@/assets/img/calendarclock.png" alt="#" class="chosse_img">
         <h2 class="chosse_txt">Alege data</h2>
      </div>
   </div>
   <h2 class="ready_text">Când vă este comod să faceți lecțiile?</h2>
   <div class="week_days">
      <div class="two_days">
         <div class="week_day_select_hour">
            <h1 class="week_day_select_text">Luni</h1>
            <div class="week_days_box">
               <div class="day_hours_box">
                     <div class="hour_box">
                        <p class="hours">00:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">01:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">02:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">03:00</p>
                     </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">04:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">05:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">06:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">07:00</p>
                  </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">08:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">09:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">10:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">11:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">12:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">13:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">14:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">15:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">16:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">17:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">18:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">19:00</p>
                  </div>
                  </div>
                  <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">20:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">21:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">22:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">23:00</p>
                  </div>
                </div>
            </div>
         </div>
         <div class="week_day_select_hour">
            <h1 class="week_day_select_text">Marți</h1>
            <div class="week_days_box" style="margin-right: 0px;">
               <div class="day_hours_box">
                     <div class="hour_box">
                        <p class="hours">00:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">01:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">02:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">03:00</p>
                     </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">04:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">05:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">06:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">07:00</p>
                  </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">08:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">09:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">10:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">11:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">12:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">13:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">14:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">15:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">16:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">17:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">18:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">19:00</p>
                  </div>
                  </div>
                  <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">20:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">21:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">22:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">23:00</p>
                  </div>
                </div>
            </div>
         </div>
      </div>
      <div class="two_days">
         <div class="week_day_select_hour">
            <h1 class="week_day_select_text">Miercuri</h1>
            <div class="week_days_box">
               <div class="day_hours_box">
                     <div class="hour_box">
                        <p class="hours">00:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">01:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">02:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">03:00</p>
                     </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">04:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">05:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">06:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">07:00</p>
                  </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">08:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">09:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">10:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">11:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">12:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">13:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">14:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">15:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">16:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">17:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">18:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">19:00</p>
                  </div>
                  </div>
                  <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">20:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">21:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">22:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">23:00</p>
                  </div>
                </div>
            </div>
         </div>
         <div class="week_day_select_hour">
            <h1 class="week_day_select_text">Joi</h1>
            <div class="week_days_box" style="margin-right: 0px;">
               <div class="day_hours_box">
                     <div class="hour_box">
                        <p class="hours">00:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">01:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">02:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">03:00</p>
                     </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">04:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">05:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">06:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">07:00</p>
                  </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">08:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">09:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">10:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">11:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">12:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">13:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">14:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">15:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">16:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">17:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">18:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">19:00</p>
                  </div>
                  </div>
                  <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">20:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">21:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">22:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">23:00</p>
                  </div>
                </div>
            </div>
         </div>
      </div>
      <div class="two_days">
         <div class="week_day_select_hour">
            <h1 class="week_day_select_text">Vineri</h1>
            <div class="week_days_box">
               <div class="day_hours_box">
                     <div class="hour_box">
                        <p class="hours">00:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">01:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">02:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">03:00</p>
                     </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">04:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">05:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">06:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">07:00</p>
                  </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">08:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">09:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">10:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">11:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">12:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">13:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">14:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">15:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">16:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">17:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">18:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">19:00</p>
                  </div>
                  </div>
                  <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">20:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">21:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">22:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">23:00</p>
                  </div>
                </div>
            </div>
         </div>
         <div class="week_day_select_hour">
            <h1 class="week_day_select_text">Sâmbătă</h1>
            <div class="week_days_box" style="margin-right: 0px;">
               <div class="day_hours_box">
                     <div class="hour_box">
                        <p class="hours">00:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">01:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">02:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">03:00</p>
                     </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">04:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">05:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">06:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">07:00</p>
                  </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">08:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">09:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">10:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">11:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">12:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">13:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">14:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">15:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">16:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">17:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">18:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">19:00</p>
                  </div>
                  </div>
                  <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">20:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">21:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">22:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">23:00</p>
                  </div>
                </div>
            </div>
         </div>
      </div>
      <div class="two_days">
         <div class="week_day_select_hour">
            <h1 class="week_day_select_text">Duminică</h1>
            <div class="week_days_box">
               <div class="day_hours_box">
                     <div class="hour_box">
                        <p class="hours">00:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">01:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">02:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">03:00</p>
                     </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">04:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">05:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">06:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">07:00</p>
                  </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">08:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">09:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">10:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">11:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">12:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">13:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">14:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">15:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">16:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">17:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">18:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">19:00</p>
                  </div>
                  </div>
                  <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">20:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">21:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">22:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">23:00</p>
                  </div>
                </div>
            </div>
         </div>
         <div class="week_day_select_hour1">
            <h1 class="week_day_select_text">Duminică</h1>
            <div class="week_days_box">
               <div class="day_hours_box">
                     <div class="hour_box">
                        <p class="hours">00:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">01:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">02:00</p>
                     </div>
                     <div class="hour_box">
                        <p class="hours">03:00</p>
                     </div>
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">04:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">05:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">06:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">07:00</p>
                  </div>
                  
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">08:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">09:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">10:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">11:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                   <div class="hour_box">
                     <p class="hours">12:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">13:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">14:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">15:00</p>
                  </div>
               </div>
               <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">16:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">17:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">18:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">19:00</p>
                  </div>
                  </div>
                  <div class="day_hours_box">
                  <div class="hour_box">
                     <p class="hours">20:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">21:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">22:00</p>
                  </div>
                  <div class="hour_box">
                     <p class="hours">23:00</p>
                  </div>
                </div>
            </div>
         </div>
      </div>
   </div>
   <h2 class="ready_text">Preferințe față de profesor</h2>
   <div class="select_gen_and_age">
      <p class="profesor_gen">Genul profesorului</p>
      <div class="select_gen">
         <div class="either_gen">
            <p class="either_gen_text">Oricare</p>
         </div>
         <div class="male">
            <p class="male_text">Masculin</p>
         </div>
         <div class="female">
            <p class="female_text">Feminin</p>
         </div>
      </div>
      <p class="profesor_gen" style="margin-top:32px;">Vârsta profesorului</p>
      <div class="select_age">
         <div class="either_gen1">
            <p class="either_gen_text">Oricare</p>
         </div>
         <div class="from_20_age">
            <p class="age_text">De la 20</p>
         </div>
         <div class="from_30_age">
            <p class="age_text">De la 30</p>
         </div>
         <div class="from_40_age">
            <p class="age_text">De la 40</p>
         </div>
      </div>
   </div>
   <h2 class="ready_text"> De ce Dvs ați decis să<br>
      schimbați profesorul?</h2>
      <div class="radiobtn_container">
      <div class="radiobtn_box" style="background:#CF0920;">
      <label class="radio_button">Nu îmi place abordarea profesorului
      <input type="radio" checked="checked" name="radio">
      <span class="checkmark"></span>
      </label>
      </div>
      <div class="radiobtn_box">
      <label class="radio_button">Nu îmi place comportamentul profesorului
      <input type="radio" name="radio">
      <span class="checkmark"></span>
      </label>
      </div>
      <div class="radiobtn_box">
      <label class="radio_button">Profesorul întârzie/nu vine la lecții
      <input type="radio" name="radio">
      <span class="checkmark"></span>
      </label>
      </div>
      <div class="radiobtn_box">
      <label class="radio_button">Cerințele mele față de profesor s-au schimbat
      <input type="radio" name="radio">
      <span class="checkmark"></span>
      </label>
      </div>
      <div class="radiobtn_box">
      <label class="radio_button">Mi s-a schimbat orarul
      <input type="radio" name="radio">
      <span class="checkmark"></span>
      </label>
      </div>
      </div>
   <div class="confirm_button">
      <button class="button" 
         style="border-radius: 24px;
         width: 180px;
         height: 40px;
         margin-bottom: 32px;
         margin-top: 40px;
         ">Confirmă</button>
   </div>
</div>
</template>

<script>
    import CalendarSchedule from './CalendarSchedule'
    import DaySchedule from './DaySchedule'
    import {todayHowString,rest,formatPrice} from '@/utils/utils';
    import store from '@/store';
    import { dateConvert, MONTH_NAMES } from '../../../../../utils/utils';
    import { mapGetters, mapActions } from 'vuex';
    import BookingErrorPopup from './popups/BookingErrorPopup';
    import Popup from '@/components/Popup';

    export default {
        name: 'BookingStep',
        components: {
            CalendarSchedule,
            DaySchedule,
            BookingErrorPopup,
            Popup,
        },
        data: function () {
            return {
                selectedDate: todayHowString(),
                selectedHour: null,
                booking_error:false,
                date_valid:false,
                view_date:{},
                list:[],
                has_prev:false,
                has_next:false,
                products:[]
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/get',
            }),
            selectedDateConvert() {
                return dateConvert(this.selectedDate)
            },
            selectedHourStart() {
                if (this.selectedHour == null) {
                    return '';
                }
                return this.selectedHour.start;
            },
            selected_day(){
                if(this.view_date){
                    if(typeof this.view_date.dow != "undefined"){
                        switch(this.view_date.dow){
                            case "0":
                                return "WK_SUN";
                            break;
                            case "1":
                                return "WK_MON";
                            break;
                            case "2":
                                return "WK_TUE";
                            break;
                            case "3":
                                return "WK_WED";
                            break;
                            case "4":
                                return "WK_THU";
                            break;
                            case "5":
                                return "WK_FRI";
                            break;
                            case "6":
                                return "WK_SAT";
                            break;
                        }
                    }
                }
                return "";
            }
        },
        methods: {
            selectedDateEvent(date,valid=true){
                this.date_valid = valid;
                this.selectedHour = null;
                this.selectedDate = date;
            },
            selectedHourEvent(hour) {
                this.selectedHour = hour;
            },
            lessonBookingEvent() {
                this.lessonBooking({
                    hourId: this.selectedHour.id,
                    date: this.selectedDate,
                })
            },
            nextStep() {
                store.commit('trialBookingFlow/currentStep', 'test-booked');
            },
            lessonBooking(lesson) {
                store.commit('loading/is', true);
                rest.call("lesson_booking",{
                    "id":lesson.hourId,
                    "date":lesson.date
                },"POST").then((response)=>{
                    store.commit('loading/is',false);
                    if(response.status == "ok"){
                        this.nextStep();
                    }else{
                        this.selectedHour = null;
                        this.selectedDate = todayHowString();
                        this.showTrialBookingErrorPopup = true;
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                    //Произошла ошибка во время записи - выведем сообщение
                    this.booking_error = true;
                    this.selectedHour = null;
                    this.selectedDate = todayHowString();
                    this.showTrialBookingErrorPopup = true;
                });
            },
            BookingErrorPopupCloseEvent(){
                this.booking_error = false;
            },
            prev(){
                if(this.has_prev){
                    this.get_lessons(-1);
                }
            },
            next(){
                if(this.has_next){
                    this.get_lessons(1);
                }
            },
            get_lessons(direction=1){
                this.list = [];
                store.commit('loading/is',true);
                rest.call("get_lessons_by_day",{
                    date:this.view_date.date?this.view_date.date:null,
                    direction:direction
                },"POST").then((response)=>{
                    this.view_date = {};
                    store.commit('loading/is',false);
                    if(response.response_date){
                        this.view_date = response.response_date;
                    }
                    if(response.list){
                        for(var x in response.list){
                            this.list.push(response.list[x]);
                        }
                    }
                    this.has_prev=response.prev;
                    this.has_next=response.next;
                }).catch((error)=>{
                    this.view_date = {};
                    store.commit('loading/is', false);
                });
            },
        },
        mounted(){
            this.get_lessons();
        },
    }
</script>

<style lang="scss" scoped>
.selected-date-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    .prev-container,.next-container{
        padding: 0px 20px;
        .icon-wrapper{
            display: flex;
            align-items: center;
            justify-content: center;
            svg{
                fill:#b5b7bc;
            }
        }
        &.active{
            cursor: pointer;
            .icon-wrapper svg{
                fill:#565758;
            }
        }
        &.prev-container{

        }
        &.next-container{

        }
    }
    .current-date-container{
        width: 100%;
        flex: 1;
        width:300px;
        .date-container{
            background: #F0F3F8;
            border-radius: 10px;
            padding:15px;
            .selected-date{
                font-family: FuturaPT;
                font-size: 24px;
                line-height: 56px;
                letter-spacing: 1.3px;
                color: #0B1022;
                font-weight: bold;
                text-transform: capitalize;
            }
            .selected-day{
                display: block;
                width: 100%;
                font-family: FuturaPT;
                font-size: 18px;
                line-height: 40px;
                letter-spacing: 1.3px;
                color: #848894;
                font-weight: bold;
                text-transform: capitalize;
            }
        }
    }
}
.primary-button-form{
    
}
.reserve_lesson_container{
    padding: 30px 44px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
}
.reserve_lesson_body{
    display: flex;
    min-height: 35rem;
    margin-top:15px;
}

  .calendar_wrapper {
    margin-right: 6rem;
  }

  .calendar_text, .day_schedule_text {
    font-family: FuturaPT;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: rgba(11, 16, 34, 0.3);
    margin-bottom: 2.5rem;
    display: inline-block;
  }

  .reserve_lesson_footer {
    width: 100%;
    display: flex;
    margin-top: 17px;
    margin-bottom: 12px;

    .button {
      margin-left: auto;
      padding: 0.75rem 2.5rem 1rem 2.5rem;
    }
  }

  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
  }

  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  .reserve_lesson-form{
    display:flex;
    flex-direction:row;
    width:100%;
    align-items: center;
    .form-wrapper{
      width:100%;
      &.button-wrapper{
        flex:1;
      }
      .form-field{
        .input-wrapper{
          font-family: FuturaPT;
          font-style: normal;
          font-weight: 500;
          font-size: 1.6rem;
          line-height: 4.6rem;
          color: #0B1022;
          position: relative;
          input{
            margin-bottom: 1rem;
            background: #f0f3f8;
            border-radius: 24rem;
            border: 0;
            outline: none;
            padding: 0 2.4rem 0 32px;
            line-height: inherit;
          }
          span.phone-mask{
            position: absolute;
            z-index: 1;
            left: 17px;
            top: 0px;
            bottom: 0px;
          }
        }
        span.label{
          font-family: FuturaPT;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: 0.5px;
          color: #0B1022;
          display: inline-block;
          width: 100%;
          clear: both;
          margin-bottom: 17px;
          position:relative;
          &.required:after{
          content: "*";
          display: inline-block;
          color: #cf0920;
          font-size: 20px;
          margin-left: 5px;
          position: absolute;
          line-height: 23px;
        }
        }
        span.helper-node{
          font-family: FuturaPT;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: 0.5px;
          color: rgba(11, 16, 34, 0.3);
          margin-bottom: 2.5rem;
          display: inline-block;
          width:100%;
        }
      }
    }
  }
  
@media (max-width:740px){
   .reserve_lesson_body{
        margin-top:15px;
    } 
}
@media (max-width:540px){
   .reserve_lesson_body{
        display: flex;
        flex-direction: column;
        .calendar_wrapper{
            margin-right:0px;
            .container.calendar{
                display: none;
                .header{
                    .month{
                        font-size: 16px !important;
                    }
                }
                .weekdays-container{
                    .day-name{
                        font-size: 16px !important;
                    }
                }
            }
            #sweetCalendar{
                width:100% !important;
            }
        }
    } 
}
</style>